// extracted by mini-css-extract-plugin
module.exports = {"icon":"PaymentType_icon__1lnj9","title":"PaymentType_title__2khfi"};